import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

export interface DicomViewerAvailability {
  available: boolean;
  studies: number;
  /** Viewer page for the exam on this origin, e.g. /dicomviewer/exam/123 */
  url?: string;
}

/**
 * Opens an exam's DICOM studies (its dicom_studies rows) in the Artisan DICOM Viewer.
 *
 * The API serves the viewer at /dicomviewer on this same origin. The viewer runs inside
 * this aweb login and gets its own access to the exam's studies from the API, so nothing
 * has to be passed along here beyond the exam's URL.
 */
@Injectable({
  providedIn: "root",
})
export class DicomViewerService {
  constructor(private http: HttpClient) {}

  /** Whether the exam has studies the viewer can open, and its URL. */
  check(examId: number): Observable<DicomViewerAvailability> {
    return this.http.get<DicomViewerAvailability>("/api/dicom/viewer/" + examId);
  }

  open(url: string): void {
    window.open(url, "_blank", "noopener");
  }
}
